// @flow

import React from 'react'
import { css } from '@emotion/core'
import { graphql } from 'gatsby'
import FormLayout from '@/layouts/FormLayout'
import { Title } from '@/components/Form'
import { LinkButton } from '@/components/Button'
import GuideSrc from '@/assets/guide.png'

type Props = {
  data: Object,
  pageContext: Object,
}
    
function getQueryParam(param: string): string {
  const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
  return searchParams ? searchParams.get(param) : "";
}

function parseLinks(linksString: string) {
  const result: { title: string; url: string }[] = [];
  const pairs = linksString.split(",");

  pairs.forEach(pair => {
	const cleaned = pair.trim().replace(/^'+|'+$/g, "");

    // Split on the *first* colon only
    const idx = cleaned.indexOf(":");
    if (idx === -1) return;

    const title = cleaned.slice(0, idx).trim();
    const url = cleaned.slice(idx + 1).trim();

	console.log(url)
    if (title && url) {
      result.push({ title: title.trim(), url: url.trim() });
    }
  });

  return result;
}

function FormSubmittedTemplate({
  pageContext: { section },
  data: {
    page: {
      data: {
        title: { text: title },
        description: { html: description },
        ctaLabel,
        ctaLink,
        displayGuideImage,
      },
    },
	settings
  },
}: Props) {

  const brochuresString = getQueryParam("brochures");
  const brochures = brochuresString ? parseLinks(brochuresString) : [];
  const generic_title = "Select Brochures to Download"
  const misc_style = "<style>.brochure-button a { text-align: left; }</style>"
  const display_title = brochuresString ? generic_title : title

  return (

    <FormLayout full={displayGuideImage === 'No'} section={section}
	  logoSrc={settings.data.company_logo.url}
      logoAlt={settings.data.company_logo.alt}>
      <div>
        {brochuresString && title && <Title large>{display_title}</Title>}
        {!brochuresString && title && <Title large>{title}</Title>}
        {!brochuresString && ctaLabel && ctaLink && (
          <LinkButton to={ctaLink.url}>{ctaLabel}</LinkButton>
        )}
        {brochuresString && (
          <div dangerouslySetInnerHTML={{ __html: description + misc_style }} />
        )}
        {brochuresString && brochures.map((link, i) => (
          <p class="brochure-button"><LinkButton to={link.url}>{link.title} Brochure</LinkButton></p>
        ))}
      </div>
      {displayGuideImage === 'Yes' && (
        <div>
          <img
            css={css`
              display: block;
              width: 100%;
            `}
            loading="lazy"
            src={GuideSrc}
            alt="cover of guide"
          />
        </div>
      )}
    </FormLayout>
  )
}

export default FormSubmittedTemplate

export const query = graphql`
  query ($uid: String!) {
    page: prismicFormSubmitted(uid: { eq: $uid }) {
      data {
        title: form_title {
          text
        }
        description {
          html
        }
        ctaLabel: cta_label
        ctaLink: cta_link {
          url
        }
        displayGuideImage: display_guide_image
      }
    }
    settings: prismicGlobalSettings {
      ...LogoSettings
    }
  }
`
